module.exports = __webpack_public_path__ + "img/sl-1.webp";